// extracted by mini-css-extract-plugin
module.exports = {"badge":"zLz-jnAuDqNYyQcdnKqwx"};